import { v4 as uuidv4 } from 'uuid';
import { getOsPlatform } from '../Utils/FetchOS';
import Cookies from 'js-cookie';

const element = document.getElementById('authorMode');
const authorMode = (element && element.getAttribute('env-runmode')) || 'None';
const gameVersion = '1.19.2';

export const PAGE_SIZE = 5;

export const sideNavId = 'sideNav';

export default authorMode === 'author';
export const constants = {
  showMsaSuccess: 'show_msa_success',
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
  bearerToken: 'bearer_token',
  adult: 'Adult',
  sid: 'sid',
  minecraft: 'Minecraft',
  msaprofile: 'msaprofile',
  buyMinecraft: 'Buy Minecraft'
};

export const walletConstants = {
  uninitialized: 'UNINITIALIZED'
};

export const editProfileName = {
  notAllowed: 'NOT_ALLOWED',
  duplicate: 'DUPLICATE',
  registered: 'ALREADY_REGISTERED',
  offensiveLanguage: 'You can’t use language that some might find offensive.',
  maxLength: 16
};

export const accordionConstants = {
  uninitialized: 'UNINITIALIZED',
  accordionDropdown: 'drop-down',
  accordionOpen: 'open',
  accordionCollapsed: 'collapsed',
  gameMinecraft: 'game_minecraft',
  gameMinecraftBedrock: 'game_minecraft_bedrock'
};

export const loginConstants = {
  loginTypeMojang: 'Mojang',
  loginTypeMSA: 'MSA'
};

export interface IDevice {
  playFabTitleId: string;
  applicationType: string;
  gameVersion: string;
  id: string;
  memory: string;
  platform: string;
  storePlatform: string;
  type: string;
  treatmentOverrides: [];
}

export interface IUser {
  tokenType: string;
  token: string;
}

export const Device: IDevice = {
  playFabTitleId: '',
  applicationType: 'MinecraftPE',
  gameVersion: gameVersion,
  id: uuidv4(),
  memory: '1024',
  platform: getOsPlatform(),
  storePlatform: 'uwp.store',
  type: getOsPlatform(),
  treatmentOverrides: []
};

export const User: IUser = {
  tokenType: 'Xbox',
  token: localStorage.getItem('PlayFabXBLToken')
};

export const playfabHeaders = {
  'Content-Type': 'application/json',
  'x-xbl-contract-version': '2'
};

export const pocketRealmsHeaders = {
  Authorization: localStorage.getItem('RealmsXBLToken'),
  'User-Agent': 'MCPE/UWP',
  'Content-Type': 'application/json',
  'Client-Version': gameVersion,
  'x-xbl-contract-version': '2'
};

export const pocketJavaRealmsHeaders = {
  Authorization: Cookies.get(constants.bearerToken),
  'Content-Type': 'application/json',
  'Client-Version': gameVersion,
  user: Cookies.get('session_username'),
  userProfileId: ''
};

export const profilePicHeaders = {
  'x-xbl-contract-version': '3',
  Authorization: localStorage.getItem('XboxXBLToken'),
  'Content-Type': 'application/json'
};

export const xboxPeopleHubHeaders = {
  'x-xbl-contract-version': '5',
  Authorization: localStorage.getItem('XboxXBLToken'),
  'Content-Type': 'application/json',
  'xbl-request-type': 'Foreground',
  'xbl-scenario-type': 'MinecraftNet', // Staylo to confirm this value before merging
  'retry-count': '0'
};

export const headerTypeJson = {
  'Content-Type': 'application/json'
};

export enum StatusCode {
  NoContent = 204,
  BadRequest = 400,
  UnAuthorized = 401,
  NotFound = 404,
  InternalServerError = 500,
  NetworkAuthenticationRequired = 511
}

export const accountSettingsConstants = {
  pageTitle: 'MY ACCOUNT'
};

export interface IBedrockRealmsList {
  id: string;
  remoteSubscriptionId: string;
  owner: string;
  ownerUUID: number;
  name: string;
  motd: string;
  defaultPermission: string;
  state: 'CLOSED' | 'OPEN' | 'ADMIN_LOCK' | 'UNINITIALIZED' | 'DELETED';
  daysLeft: number;
  expired: boolean;
  expiredTrial: boolean;
  gracePeriod: boolean;
  worldType: string;
  players: string;
  maxPlayers: number;
  minigameName: string;
  minigameId: string;
  minigameImage: string;
  activeSlot: number;
  slots: string;
  member: boolean;
  clubId: number;
  subscriptionRefreshStatus: string;
}

export const BedrockRealmsList: IBedrockRealmsList = {
  id: 'id',
  remoteSubscriptionId: 'remoteSubscriptionId',
  owner: 'owner',
  ownerUUID: 0,
  name: 'name',
  motd: 'motd',
  defaultPermission: 'defaultPermission',
  state: 'UNINITIALIZED',
  daysLeft: 0,
  expired: false,
  expiredTrial: true,
  gracePeriod: true,
  worldType: 'worldType',
  players: 'players',
  maxPlayers: 0,
  minigameName: 'minigameName',
  minigameId: 'minigameId',
  minigameImage: 'minigameImage',
  activeSlot: 0,
  slots: 'slots',
  member: true,
  clubId: 0,
  subscriptionRefreshStatus: 'subscriptionRefreshStatus'
};

export const key = {
  tab: 'Tab',
  esc: 'Escape',
  enter: 'Enter',
  arrowUp: 'ArrowUp',
  arrowDown: 'ArrowDown',
  home: 'Home',
  end: 'End',
  space: ' '
};
export enum PaymentStatus {
  ACTIVE = 'active',
  CANCELLED = 'canceled'
}

export const profileTagConstants = {
  gamertagUnavailable: 'unavailable',
  xboxGamerPicDimentions: '&w=100&h=100',
  isXbox360Gamerpic: 'IsXbox360Gamerpic',
  appDisplayPicRaw: 'AppDisplayPicRaw',
  paddingMode: 'Padding',
  stretchMode: 'Stretch',
  defaultImagePath: '/content/dam/games/minecraft/logos/DefaultGamerPic.png'
};

export const gameCardConstatns = {
  playfabDungeonsGameCode: 'C839E',
  playfabBedrockGameCode: '20CA2',
  gameJava: 'game_minecraft',
  gameDungeons: 'game_dungeons',
  gameBedrock: 'game_minecraft_bedrock'
};

export const cookiesList = ['access_token', 'bearer_token', 'session_username', 'hasMcJavaEntitlement'];

export const XBLTokenKeys = ['XboxXBLToken', 'PlayFabXBLToken', 'MarketplaceXBLToken', 'RealmsXBLToken'];

export const localStorageList = [...XBLTokenKeys, 'XBLXid', 'XBLTokensNotAfter', 'MCToken', 'LoginType', 'IsNewProfileEnabled', 'entitlements', 'flights'];

export const launcherConstants = {
  refLauncherParam: 'ref=launcher',
  launcherParam: 'LauncherParam',
  utmLauncherParam: '?utm_source=launcher',
  utmSource: 'utm_source',
  launcher: 'launcher'
};
export const tableConstants = {
  mobileViewBreakpoint: '767.98px'
};
export const imageList = {
  inviteIconDisabled: '/content/dam/games/minecraft/logos/icon-add_player_24px.svg',
  inviteIconPrimary: '/content/dam/games/minecraft/logos/white-icon-add_player_24px.svg',
  blockIcon: '/content/dam/games/minecraft/logos/icon-block_20px.svg',
  deleteIcon: '/content/dam/games/minecraft/logos/icon-delete_black_24px.svg',
  selectedCheckmark: '/content/dam/games/minecraft/logos/selected-checkmark.svg',
  copyIcon: '/content/dam/games/minecraft/logos/icon-copy.svg',
  copyIconDisabled: '/content/dam/games/minecraft/logos/icon-copy-disabled.svg',
  memberImage: '/content/dam/games/minecraft/logos/member (1).svg',
  operatorImage: '/content/dam/games/minecraft/logos/operator (1).svg',
  visitorIcon: '/content/dam/games/minecraft/logos/Visitor (1).svg',
  javaImagePath: '/content/dam/games/minecraft/key-art/Java-Game-Image.png',
  dungeonsImagePath: '/content/dam/games/minecraft/key-art/Minecraft-dungeons.png',
  bedrockImagePath: '/content/dam/games/minecraft/key-art/Minecraft-bedrock.png',
  legendsImagePath: '/content/dam/games/minecraft/key-art/MinecraftLegends_398x200.jpg',
  checkmarkWhiteIcon: '/content/dam/games/minecraft/logos/Icon_Checkmark_24px_White.svg'
};
export const toastIcons = {
  Activated: '/content/dam/games/minecraft/logos/Checkmark-icon.svg',
  Blocked: '/content/dam/games/minecraft/logos/Blocked.svg',
  Copied: '/content/dam/games/minecraft/logos/icon-copy.svg',
  Downloaded: '/content/dam/games/minecraft/logos/Download.svg',
  Invited: imageList.inviteIconPrimary,
  Permission: '/content/dam/games/minecraft/logos/Permission.svg',
  Removed: '/content/dam/games/minecraft/logos/Removed.svg',
  Replace: '/content/dam/games/minecraft/logos/Replace.svg',
  Restored: '/content/dam/games/minecraft/logos/Restored.svg',
  Saved: '/content/dam/games/minecraft/logos/Saved.svg',
  Unblocked: '/content/dam/games/minecraft/logos/Unblocked.svg',
  Warning: '/content/dam/games/minecraft/logos/Warning.svg',
  Qr: '/content/dam/games/minecraft/logos/qr.svg',
  Close: '/content/dam/minecraft/onestorewallet/images/toastifyClose.svg'
};

export enum pageBackgroundConstants {
  purpleColor = 'purple',
  greyColor = 'grey',
  green = 'green'
}

export const events = {
  click: 'click',
  keydown: 'keydown'
};

export interface IPeopleData {
  totalCount: number;
  people: IPeopleList[];
}

export interface IPeopleList {
  xuid: string;
  addedDateTimeUtc: string;
  isFavorite: boolean;
  isFollowedByCaller: boolean;
  isFollowingCaller: boolean;
  isIdentityShared: boolean;
  isSquadMateWith: boolean;
  isUnfollowingFeed: boolean;
  socialNetworks: [];
}

export const editProfileRoute = 'msaprofile/mygames/editprofile';
export const onestoreQueryParam = 'onestoreSubscription';
export const legacyRedeemRoute = '/msaprofile/redeem';

export const dropdownPortalId = 'dropdownPortalID';

export const flights = 'flights';
export const APPLICATION_PROFILE = 'Profile';
export const MODEL_SERVICE_NAME = 'AEM Model';

export enum ENTITLEMENT_SOURCE {
  TRIAL = 'TRIAL'
}
